export default function mapDocument(document) {
	if (!document) {
		return null;
	}

	if (typeof document.data !== "function") {
		return document;
	}

	return {
		...document.data(),
		id: document.id,
		ref: document.ref,
		exists: document.exists,
	};
}
